import { render, staticRenderFns } from "./CreateSubAdmin.vue?vue&type=template&id=37fb8643&scoped=true"
import script from "./CreateSubAdmin.vue?vue&type=script&lang=js"
export * from "./CreateSubAdmin.vue?vue&type=script&lang=js"
import style0 from "./CreateSubAdmin.vue?vue&type=style&index=0&id=37fb8643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb8643",
  null
  
)

export default component.exports